var map = {
	"./app-config.dev.json": 48970,
	"./app-config.module": 85153,
	"./app-config.module.ts": 85153,
	"./app-config.prod.json": 33807,
	"./app-config.stg.json": 18596,
	"./app-config.uat.json": 47570,
	"src/app/config/app-config.dev.json": 48970,
	"src/app/config/app-config.module": 85153,
	"src/app/config/app-config.module.ts": 85153,
	"src/app/config/app-config.prod.json": 33807,
	"src/app/config/app-config.stg.json": 18596,
	"src/app/config/app-config.uat.json": 47570
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20866;